// @flow
import React from "react";
import SvgButton from "../SvgButton";
import ArrowDownIcon from "../../assets/icons/other/bottomCaret.svg";
import ArrowUpIcon from "../../assets/icons/other/upCaret.svg";

import styles from "./Pagination.scss";

type PaginationProps = {
  currentPage: number,
  className: string,
  getNextPage: (page: number) => void,
  getPreviousPage: (page: number) => void,
  maxPages: number,
  isPaginationHidden: boolean
};

const Pagination = ({
  className,
  currentPage,
  getNextPage,
  getPreviousPage,
  maxPages,
  isPaginationHidden
}: PaginationProps) =>
  isPaginationHidden ? null : (
    <div className={className}>
      <SvgButton
        className={styles.arrowLeft}
        src={ArrowUpIcon}
        alt="vorherige Seite"
        isDisabled={currentPage === 1}
        onClick={getPreviousPage}
        data-testid="leftArrow"
      />
      <span className={styles.paginator}>{`${currentPage} / ${maxPages}`}</span>
      <SvgButton
        className={styles.arrowRight}
        src={ArrowDownIcon}
        alt="nächste Seite"
        onClick={getNextPage}
        isDisabled={currentPage === maxPages}
        data-testid="rightArrow"
      />
    </div>
  );

export default Pagination;
